<div class="container-fluid">
  <ziro-fieldset-header [legend]="'tkey;pages.details.agentSettings.header'">
    <ziro-select fieldId="resourceGroup"></ziro-select>
    <ziro-select fieldId="team"></ziro-select>
    <ziro-text fieldId="alias"></ziro-text>
    <ziro-checkbox fieldId="automaticAvailable"></ziro-checkbox>
  </ziro-fieldset-header>

  <ziro-fieldset-header [legend]="'tkey;pages.details.agentSettings.skills.header'">
    <ziro-navset data-automation="skills-navset" fieldId="uccxNavset"></ziro-navset>
  </ziro-fieldset-header>
</div>
